import { Route } from '@angular/router';
import { pendingChangesGuard } from '../../core/guards/pending-changes.guard';
import { pageAccessGuard } from '../../core/guards/page-access.guard';
import { getNavigationGroup } from '../../core/config/app-navigation';

const ajustesNavigation = getNavigationGroup('ajustes');
const parametrosItem = ajustesNavigation.items.find((item) => item.key === 'parametros');
const rolesItem = ajustesNavigation.items.find((item) => item.key === 'gestion-roles');
const syncSociosItem = ajustesNavigation.items.find((item) => item.key === 'sync-socios');
const avanceEtapasItem = ajustesNavigation.items.find((item) => item.key === 'avance-etapas');
const logsAuditoriaItem = ajustesNavigation.items.find((item) => item.key === 'logs-auditoria');

if (!parametrosItem) {
  throw new Error('No navigation item configured for "parametros".');
}

if (!rolesItem) {
  throw new Error('No navigation item configured for "gestion-roles".');
}

if (!syncSociosItem) {
  throw new Error('No navigation item configured for "sync-socios".');
}

if (!avanceEtapasItem) {
  throw new Error('No navigation item configured for "avance-etapas".');
}

if (!logsAuditoriaItem) {
  throw new Error('No navigation item configured for "logs-auditoria".');
}

export const ajustesRoutes: Route[] = [
  {
    path: 'ajustes',
    redirectTo: '/ajustes/parametros',
    pathMatch: 'full',
  },
  {
    path: parametrosItem.path.replace(/^\//, ''),
    data: {
      pageKey: parametrosItem.pageKey,
      title: parametrosItem.title,
      description: parametrosItem.description,
    },
    canActivate: [pageAccessGuard],
    canDeactivate: [pendingChangesGuard],
    loadComponent: () => import('./pages/parametros/parametros.page').then((m) => m.AjustesPage),
  },
  {
    path: rolesItem.path.replace(/^\//, ''),
    data: {
      pageKey: rolesItem.pageKey,
      title: rolesItem.title,
      description: rolesItem.description,
    },
    canActivate: [pageAccessGuard],
    canDeactivate: [pendingChangesGuard],
    loadComponent: () =>
      import('./pages/gestion-roles/gestion-roles.page').then((m) => m.GestionRolesPage),
  },
  {
    path: syncSociosItem.path.replace(/^\//, ''),
    data: {
      pageKey: syncSociosItem.pageKey,
      title: syncSociosItem.title,
      description: syncSociosItem.description,
    },
    canActivate: [pageAccessGuard],
    loadComponent: () =>
      import('./pages/customer-sync/customer-sync.page').then((m) => m.CustomerSyncPage),
  },
  {
    path: avanceEtapasItem.path.replace(/^\//, ''),
    data: {
      pageKey: avanceEtapasItem.pageKey,
      title: avanceEtapasItem.title,
      description: avanceEtapasItem.description,
    },
    canActivate: [pageAccessGuard],
    loadComponent: () =>
      import('./pages/avance-etapas/avance-etapas.page').then((m) => m.AvanceEtapasPage),
  },
  {
    path: logsAuditoriaItem.path.replace(/^\//, ''),
    data: {
      pageKey: logsAuditoriaItem.pageKey,
      title: logsAuditoriaItem.title,
      description: logsAuditoriaItem.description,
    },
    canActivate: [pageAccessGuard],
    loadComponent: () =>
      import('./pages/log-y-auditoria/log-y-auditoria.page').then((m) => m.LogYAuditoriaPage),
  },
  {
    path: 'ajustes/vaucher',
    redirectTo: '/ajustes/parametros',
    pathMatch: 'full',
  },
  {
    path: 'ajustes/mostrador',
    redirectTo: '/ajustes/parametros',
    pathMatch: 'full',
  },
  {
    path: 'ajustes/packaging',
    redirectTo: '/ajustes/parametros',
    pathMatch: 'full',
  },
];
